const getCsrfToken = () => document.querySelector(
	'input[name=csrfmiddlewaretoken]'
).value

export { getCsrfToken }

export default ({ url, body, ...opts }) => fetch(url, {
	method: 'POST',
	body: JSON.stringify(body),
	headers: {
		'X-CSRFToken': getCsrfToken(),
		'Accept': 'application/json, text/plain',
		'Content-Type': 'application/json',
	},
	...opts,
})
.then(resp => resp.json())
.catch(err => ({ errors: { error: [err] } }))
